<button
  class="btn btn-vipps btn-vipps-size-{{size}} {{extraClasses}}"
  [class.selected]="selected"
>

  <svg xmlns="http://www.w3.org/2000/svg" height="40" width="100" xml:space="preserve" y="0" x="0" id="Layer_1"
       version="1.1" viewBox="57.5 8 50 50">
    <path id="path149" d="M28 22l5.1 14.9 5-14.9H44l-8.8 22.1h-4.4L22 22z" class="st0"/>
    <path id="path151" d="M141.4 38.1l14.9-5.1-14.9-5v-6l22.1 8.8v4.4L141.4 44z" class="st1"/>
    <path id="path153" d="M28 44l5.1 14.9 5-14.9H44l-8.8 22.1h-4.4L22 44z" class="st1"/>
    <path id="path155" d="M38.1 22.1L33 7.2l-5 14.9h-6L30.9 0h4.4l8.8 22.1z" class="st1"/>
    <path id="path157" d="M22.1 28L7.2 33.1l14.9 5.1v5.9L0 35.3v-4.4L22.1 22z" class="st1"/>
    <path id="path159"
          d="M57.3 40.6c3.7 0 5.8-1.8 7.8-4.4 1.1-1.4 2.5-1.7 3.5-.9 1 .8 1.1 2.3 0 3.7-2.9 3.8-6.6 6.1-11.3 6.1-5.1 0-9.6-2.8-12.7-7.7-.9-1.3-.7-2.7.3-3.4 1-.7 2.5-.4 3.4 1 2.2 3.3 5.2 5.6 9 5.6zm6.9-12.3c0 1.8-1.4 3-3 3s-3-1.2-3-3 1.4-3 3-3 3 1.3 3 3z"
          class="st0"/>
    <path id="path161"
          d="M78.3 22v3c1.5-2.1 3.8-3.6 7.2-3.6 4.3 0 9.3 3.6 9.3 11.3 0 8.1-4.8 12-9.8 12-2.6 0-5-1-6.8-3.5v10.6h-5.4V22zm0 11c0 4.5 2.6 6.9 5.5 6.9 2.8 0 5.6-2.2 5.6-6.9 0-4.6-2.8-6.8-5.6-6.8s-5.5 2.1-5.5 6.8z"
          class="st0"/>
    <path id="path163"
          d="M104.3 22v3c1.5-2.1 3.8-3.6 7.2-3.6 4.3 0 9.3 3.6 9.3 11.3 0 8.1-4.8 12-9.8 12-2.6 0-5-1-6.8-3.5v10.6h-5.4V22zm0 11c0 4.5 2.6 6.9 5.5 6.9 2.8 0 5.6-2.2 5.6-6.9 0-4.6-2.8-6.8-5.6-6.8-2.9 0-5.5 2.1-5.5 6.8z"
          class="st0"/>
    <path id="path165"
          d="M132.3 21.4c4.5 0 7.7 2.1 9.1 7.3l-4.9.8c-.1-2.6-1.7-3.5-4.1-3.5-1.8 0-3.2.8-3.2 2.1 0 1 .7 2 2.8 2.4l3.7.7c3.6.7 5.6 3.1 5.6 6.3 0 4.8-4.3 7.2-8.4 7.2-4.3 0-9.1-2.2-9.8-7.6l4.9-.8c.3 2.8 2 3.8 4.8 3.8 2.1 0 3.5-.8 3.5-2.1 0-1.2-.7-2.1-3-2.5l-3.4-.6c-3.6-.7-5.8-3.2-5.8-6.4.1-5 4.6-7.1 8.2-7.1z"
          class="st0"/></svg>
</button>
